import Helper from './Helper';

class AccordionIE {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        var panel = el.nextElementSibling;
        if(el.classList.contains('active')){
          panel.style.maxHeight = null;
          el.classList.remove('active');
        } else{
          el.classList.add('active');
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

}

export default AccordionIE;
